var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranscript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ff814a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m8.741 27.861h33.344",
    fill: "none",
    strokeWidth: 2.4137
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m8.741 32.684h33.344",
    fill: "none",
    strokeWidth: 2.4137
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m8.741 18.204h33.344",
    fill: "none",
    strokeWidth: 2.4137
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m8.741 23.033h33.344",
    fill: "none",
    strokeWidth: 2.4137
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m8.741 37.518h17.047",
    fill: "none",
    strokeWidth: 2.4137
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m50.112 39.339v-38.132h-48.905v67.743h48.905v-3.427",
    fill: "none",
    strokeWidth: 2.4137
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m61.207 49.737c0 6.1369-4.9731 11.109-11.099 11.109-6.1351-2.29e-4 -11.108-4.9722-11.108-11.109 0-6.1259 4.9731-11.099 11.108-11.099 6.1259 0 11.099 4.9731 11.099 11.099z",
    fill: "none",
    strokeWidth: 2.4137
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m48.127 49.263v2.2269c0 1.12 0.903 2.033 2.023 2.033 1.119 0 2.0321-0.91305 2.0321-2.033v-2.2269h-4.055zm0 0",
    fill: "#ff814a",
    strokeLinecap: "round",
    strokeWidth: 0.7278
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m52.183 46.914c0-1.119-0.91305-2.033-2.0321-2.033-1.12 0-2.023 0.91396-2.023 2.033v0.89295h4.056v-0.89295zm0 0",
    fill: "#ff814a",
    strokeLinecap: "round",
    strokeWidth: 0.7278
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m45.979 50.904c0 2.2801 1.853 4.1329 4.132 4.1329 2.2701 0 4.122-1.853 4.122-4.1329",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 0.7278
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(17.104 0 0 17.104 66.22 0)",
    d: "m50.183 56.712v-1.592",
    fill: "none",
    strokeWidth: 1.0385
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscript);
export default __webpack_public_path__ + "static/media/transcript.bf2a662c92dbfecfffe62a7412e67133.svg";
export { ForwardRef as ReactComponent };